import React, { useEffect } from 'react';
import './css/Fonts.css';
import './css/dl.css';
import Provider from 'react-redux/es/components/Provider';
import store from './store';
import theme from './config/theme';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Layout from './layout/Layout';
import Auth0ProviderWithHistory from './auth/auth0-provider-with-history';
import Login from './main/login/Login';
import SocketService from './services/socket';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { deleteLoginFromLocalStorage } from './auth/store/loginSlice';
import 'react-datepicker/dist/react-datepicker.css';
import Logout from './main/login/Logout';
// No browser monitoring: Sentry recorded every customer session (removed 2026-10-23). The backend keeps its own.

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

function App() {
  if (localStorage.getItem('hammurabi-user')) {
    deleteLoginFromLocalStorage();
  }

  useEffect(() => {
    if (urlParams.get('sbm')) {
      localStorage.setItem('HammMID', urlParams.get('sbm'));
    }
    if (urlParams.get('lr')) {
      localStorage.setItem('HammLoginRedirect', urlParams.get('lr'));
    }
  }, []);

  // Envuelve el componente con ErrorBoundary solo en producción
  const AppContent = () => (
    <SocketService>
      <Provider store={store}>
        <CssBaseline />
        <ToastContainer theme="colored" />
        <BrowserRouter>
          <Auth0ProviderWithHistory>
            <ThemeProvider theme={theme}>
              <Switch>
                <Route path="/logout" component={Logout} />
                <Route path="/login" component={Login} />
                <Route path="*" component={Layout} />
              </Switch>
            </ThemeProvider>
          </Auth0ProviderWithHistory>
        </BrowserRouter>
      </Provider>
    </SocketService>
  );

  return <AppContent />;
}

export default App;